<script lang="ts">
import { onMount } from "svelte";
import { createEventDispatcher } from 'svelte';
import Icon from "./Icon.svelte";
    let modal: HTMLDivElement;
    let modal_instance;
    export let title = "";
    export const open = function()
    {
        M.Modal.getInstance(modal).open();
    };
    export const close = function()
    {
        M.Modal.getInstance(modal).close();
    };
    onMount(
        ()=>{
            M.Modal.init(modal, {
                "onOpenStart": ()=> dispatch_event("onOpenStart"),
                "onOpenEnd": ()=>dispatch_event("onOpenEnd"),
                "onCloseStart": ()=>dispatch_event("onCloseStart"),
                "onCloseEnd": ()=>dispatch_event("onCloseEnd")
            });
        }
    );
    const dispatch = createEventDispatcher();
    function dispatch_event(event_name: string)
    {
        dispatch(event_name, {});
    }
</script>

<div bind:this="{modal}" class="modal">
    <h2 class="modal-header">
        <button class="waves-effect modal-close waves-red btn-flat right">
            <Icon class_list={["large"]} icon="close"></Icon>
            </button
        >
        </h2>
    <div class="modal-content">
        {#if title}
            <h4>{title}</h4>
        {/if}
        <slot />
    </div>
    <!-- <div class="modal-footer">
        <button class="modal-close waves-effect waves-red btn-flat"
            >Chiudi</button
        >
    </div> -->
</div>
